import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'reactstrap'
import { totalGuests } from 'Utils/guestHelpers'
import FormErrorMessages from 'Shared/Formik/FormErrorMessages'
import FormQuantityButtons from 'Shared/Formik/FormQuantityButtons'

const ReservationGuests = ({ displayExtraVehicle, inputStyles, loading, onChange, validations, values }) => {
  const [allowMore, setAllowMore] = useState(true)
  const [maxValuesErrors, setMaxValuesErrors] = useState([])

  const { areGuestsRequired, guests } = validations
  const { adults, extraVehicles, children, maxPeople, pets, useGuests } = guests
  const adultsLabel = useGuests ? 'Guests' : 'Adults'
  const currentTotalGuests = totalGuests({ adults: values.adults, children: values.children })

  const appendMaxValuesError = (maxValue = 0, type = 'people') => {
    const message = `This site only accepts up to ${maxValue} ${type}`

    if (maxValuesErrors.includes(message)) return

    setMaxValuesErrors(prev => [...prev, message])
  }

  useEffect(() => {
    setAllowMore(currentTotalGuests < maxPeople)
  }, [currentTotalGuests])

  useEffect(() => {
    if (values.vehicles > extraVehicles?.max)
      appendMaxValuesError(extraVehicles?.max, 'extra vehicles')
    if (currentTotalGuests > maxPeople)
      appendMaxValuesError(maxPeople, 'people')
    if (values.pets > pets?.max)
      appendMaxValuesError(pets?.max, 'pets')
    if (values.children > children?.max)
      appendMaxValuesError(children?.max, 'children')
  }, [values])

  return (
    <>
      <Row className="mb-4">
        <Col lg={6}>
          <FormQuantityButtons {...inputStyles} enabled={allowMore}
                               helperText={useGuests ? '' : `(Ages ${adults.ageRange})`}
                               isRequired={areGuestsRequired} label={adultsLabel} max={adults.max}
                               name="guests.adults" onChange={onChange} />
        </Col>

        {children && !useGuests && (
          <Col lg={6}>
            <FormQuantityButtons {...inputStyles} enabled={allowMore} helperText={`(Ages ${children.ageRange})`}
                                 label="Children" max={children.max} min={0} name="guests.children"
                                 onChange={onChange} />
          </Col>
        )}

        {pets && (
          <Col lg={6}>
            <FormQuantityButtons {...inputStyles} label="Pets" max={pets.max} min={0} name="guests.pets"
                                 onChange={onChange} />
          </Col>
        )}

        {displayExtraVehicle && (
          <Col lg={6}>
            <FormQuantityButtons {...inputStyles} label="Extra Vehicles" max={extraVehicles?.max} min={0}
                                 name="guests.vehicles" onChange={onChange} />
          </Col>
        )}
      </Row>

      {!loading && maxValuesErrors.length > 0 && <FormErrorMessages errors={maxValuesErrors} />}
    </>
  )
}

ReservationGuests.defaultProps = {
  displayExtraVehicle: false,
  loading: false,
  onChange: null,
  validations: {
    areGuestsRequired: true,
    guest: {
      adults: {
        ageRange: '',
        max: 0,
      },
      extraVehicles: {
        max: 0,
      },
      children: {
        ageRange: '',
        max: 0,
      },
      maxPeople: 0,
      pets: {
        max: 0,
      },
    },
  },
}

ReservationGuests.propTypes = {
  displayExtraVehicle: PropTypes.bool,
  inputStyles: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  validations: PropTypes.shape({}),
  values: PropTypes.shape({}).isRequired,
}

export default ReservationGuests
